import { type Theme, useMediaQuery } from "@mui/material";
import type { ReactNode } from "react";

export interface IResponsiveRenderProps {
  mediaQuery: Parameters<typeof useMediaQuery<Theme>>[0];
  children: ReactNode;
}

export const ResponsiveRender = ({ mediaQuery, children }: IResponsiveRenderProps) => {
  if (useMediaQuery(mediaQuery)) {
    return children;
  }
  return null;
};
